import React, { useEffect, useState } from 'react';
import './ProducerSelector.scss';

import { ProducerListStore } from '../producersList';
import { useDispatch } from 'react-redux';
import { Producer, ProducerType } from '../../models/producerClass';

import { PeopleService } from '../../services/people-service';
import { container } from 'tsyringe';
import { SET_PRODUCERS } from '../../redux/producers/producersReducer';

const ProducerSelector = () => {

  const [peopleService] = useState(container.resolve(PeopleService));

  const Uuids = [
    '7b40ad91-acb1-484a-9661-bca677942a84',
    '538226be-c9a0-4013-9e52-3a8341aeed7b',
    '22e5c72f-40b8-4f01-a8f3-e36e9dd8c252',
    '33429a3f-8cbe-4231-8c8f-776fef3e8a2c',
    'd96d0de8-4a61-4a36-a47e-32af7e7f6242',
    '4d2a527c-a403-4ced-9eb9-e09fe756d177',
    '987ebb53-c673-400f-9e4a-c83b73a8e292',
    'f6657954-b7af-4f06-8596-539127203e95',
    'dac8a68f-517b-465e-89bf-bef51f6fd7bc',
    '2ce45d1a-5ac3-41dc-ab5b-2dcdfa003f75',
    '6afb2148-e0ed-4f00-937c-f9b4e4cb1602',
    'd49a1065-4441-472e-a52f-794d0b4d0bfd',
    '824ea9b7-19fa-4acf-9dcb-3452d68a7153',
    '724082f7-7a6f-49e6-b82d-2e2f281175e9',
    '2b3416d3-1777-4dcb-b95d-8f98825e610d',
    '7fe2395c-8343-42d8-8caa-50b019accb10',
    '3497700d-f4a2-4686-8bad-ebba227aa44f',
    '2faba632-1d93-40aa-85ba-f72bd79d9a60',
    'c1b1a4fd-47e5-42f5-93dd-c2060acdef1c',
    'c9222c61-2b18-488b-bcf3-942baf9e5b82',
    '58ad1298-327b-4d9a-8789-5c6f5370883f',
    'fddaa469-1460-49dd-8a4c-41f9cfdf029e',
    '640c670a-ea3f-4d32-84b1-977abd482876',
    'e0f6dcad-0588-4371-8cbe-eee432e94fdd',
    '32dd5dfe-fa6e-484f-9003-6ade555a6bca',
    'f5a64433-e066-49ca-96e9-0e4f083da7b7',
  ];

  const videoPath = process.env.PUBLIC_URL + '/videos/'

  const initialProducers = [
    { url: 'webrtc00', stream: 'webrtc00', streamIndex: 0, name: 'Me', number: 1, isLive: true, isSpotted: false, id: '7b40ad91-acb1-484a-9661-bca677942a84', timezone: 'Europe/Paris'},
    { url: videoPath + 'StudioPresentation_1.mp4', stream: 'webrtc-content-remote', streamIndex: 1, name:'Jessica Lewis\'s screen', number: 0, isLive: false, isSpotted: false,
    id: '538226be-c9a0-4013-9e52-3a8341aeed7b', timezone: 'America/New_York'},
    { url: videoPath + 'jessica-lewis.mp4', stream: 'remotevideo01', streamIndex: 2, name:'Jessica Lewis', number: 0, isLive: false, isSpotted: false,
    id: '22e5c72f-40b8-4f01-a8f3-e36e9dd8c252', timezone: 'America/New_York'},
    { url: videoPath + 'melissa-parker.mp4', stream: 'remotevideo02', streamIndex: 3, name:'Melissa Parker', number: 0, isLive: false, isSpotted: false,
    id: '33429a3f-8cbe-4231-8c8f-776fef3e8a2c', timezone: 'America/New_York'},
    { url: videoPath + 'peter-casey.mp4', stream: 'remotevideo03', streamIndex: 4, name:'Peter Casey', number: 0, isLive: false, isSpotted: false,
    id: 'd96d0de8-4a61-4a36-a47e-32af7e7f6242', timezone: 'America/New_York'},
    { url: videoPath + 'larry-david.mp4', stream: 'remotevideo04', streamIndex: 5, name:'Larry David', number: 0, isLive: false, isSpotted: false,
    id: '4d2a527c-a403-4ced-9eb9-e09fe756d177', timezone: 'Europe/Paris'},
    { url: videoPath + 'elisa-burk.mp4', stream: 'remotevideo05', streamIndex: 6, name:'Elisa Burk', number: 0, isLive: false, isSpotted: false,
    id: '987ebb53-c673-400f-9e4a-c83b73a8e292', timezone: 'America/New_York'},
    { url: videoPath + 'robert-howard.mp4', stream: 'remotevideo06', streamIndex: 7, name:'Robert Howard', number: 0, isLive: false, isSpotted: false,
    id: 'f6657954-b7af-4f06-8596-539127203e95', timezone: 'Asia/Kolkata'},
    { url: videoPath + 'bob-newman.mp4', stream: 'remotevideo07', streamIndex: 8, name:'Bob Newman', number: 0, isLive: false, isSpotted: false,
    id: 'dac8a68f-517b-465e-89bf-bef51f6fd7bc', timezone: 'Asia/Hong_Kong'},
    { url: videoPath + 'ben-lawrens.mp4', stream: 'remotevideo08', streamIndex: 9, name:'Ben Lawrens', number: 0, isLive: false, isSpotted: false,
    id: '2ce45d1a-5ac3-41dc-ab5b-2dcdfa003f75', timezone: 'America/New_York'},
    { url: videoPath + 'laura-white.mp4', stream: 'remotevideo09', streamIndex: 9, name:'Laura White', number: 0, isLive: false, isSpotted: false,
    id: '6afb2148-e0ed-4f00-937c-f9b4e4cb1602', timezone: 'America/New_York'},
    { url: '', streamIndex: 11, name:'', number: 0, stream: 'remotevideo11', isLive: false, isSpotted: false,
    id: 'd49a1065-4441-472e-a52f-794d0b4d0bfd', timezone: 'America/New_York'},
    { url: '', streamIndex: 12, name:'', number: 0, stream: 'remotevideo12', isLive: false, isSpotted: false,
    id: '824ea9b7-19fa-4acf-9dcb-3452d68a7153', timezone: 'America/New_York'},
    { url: '', streamIndex: 13, name:'', number: 0, stream: 'remotevideo13', isLive: false, isSpotted: false,
    id: '724082f7-7a6f-49e6-b82d-2e2f281175e9', timezone: 'America/New_York'},
    { url: '', streamIndex: 14, name:'', number: 0, stream: 'remotevideo14', isLive: false, isSpotted: false,
    id: '2b3416d3-1777-4dcb-b95d-8f98825e610d', timezone: 'America/New_York'},
    { url: '', streamIndex: 15, name:'', number: 0, stream: 'remotevideo15', isLive: false, isSpotted: false,
    id: '7fe2395c-8343-42d8-8caa-50b019accb10', timezone: 'America/New_York'},
  ];

  const dispatch = useDispatch();
  const [producers, setProducers] = useState([]);

  useEffect(() => {

    let index = 0;
    const prods = [];
    // run only when empty
    do {
      // const newProducer = new Producer(
      //   index === 0 ? 'webrtc00' : '', '', Uuids[index], 0, 'America/New_York', index
      // )
      // newProducer.callQuality = 5;
      // newProducer.orderRank = newProducer.url !== '' ? (index + 1) * 10 : Number.MAX_SAFE_INTEGER;
      // newProducer.orderRank = Number.MAX_SAFE_INTEGER;
      // newProducer.liveRank = newProducer.orderRank;

      const newProducer = new Producer(
        initialProducers[index].url,
        index === 0 ? 'Me' : index <=10 ? initialProducers[index].name : '',
        Uuids[index], 0, 'America/New_York', index,
        index === 0, // isSelf true for index 0
        )
      newProducer.participantGuid = newProducer.id;
      newProducer.orderRank = newProducer.url !== '' ? (index + 1) * 10 : Number.MAX_SAFE_INTEGER;

      if (initialProducers[index].stream === 'webrtc-content-remote') {
        newProducer.type = ProducerType.CONTENT_SHARING;
      }

      prods.push(newProducer);
      console.log('NC', newProducer)

      if (newProducer.url !== '' ) {
        peopleService.addPeople(newProducer.id, newProducer.url, newProducer.name, newProducer.type);
      }
    } while (++index < 16);
    // } while (++nextRank < initialProducers.length);

    // setTimeout(() => {
    // set in timer else we got a https://stackoverflow.com/questions/62336340/cannot-update-a-component-while-rendering-a-different-component-warning from LiveControls
    setProducers(prods);
    dispatch({ type: SET_PRODUCERS, payload: prods });
    // }, 200);

  }, []);

  return (
    <div className="ProducerSelector">

      {/* <button onClick={() => addProducer()}>Add Presenter</button> */}
      {producers.length > 0 &&
        <>
          <div className="App-producers" style={{ margin: "0 10px" }}>
            <ProducerListStore></ProducerListStore>
          </div>

          {/* <ProducerMenu></ProducerMenu> */}
        </>
      }

    </div>
  );
}

export default ProducerSelector;
